module.exports = __webpack_public_path__ + "static/ND_Patientsite_homepage_slider3-mobile-7c796778344a9544e972caf7b1ad0802.png";